import React from "react";
import { Clock } from "./Clock/Clock";
import { Meteo } from "./Meteo/Meteo";
export const WidgetComponent = (props) => {
    if (props.widget.type === "meteo")
        return React.createElement(Meteo, { widget: props.widget });
    else
        return React.createElement(Clock, { widget: props.widget });
};
